import { useAuthenticationContext } from '../../authentication/AuthenticationContext';

export enum ToggledFeature {
  CLIENT_PORTAL = 'CLIENT_PORTAL',
  PORTAL_ADMINISTRATION = 'PORTAL_ADMINISTRATION',
  DOCUMENT_STORAGE = 'DOCUMENT_STORAGE',
  AILAUNCHER = 'AILAUNCHER',
}

export default function useFeatureToggleService() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const teamId = useAuthenticationContext()?.user.teamId;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const isForDefaultTeams = [
    1,
    2,
    697,
  ].includes(teamId || 0);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const isForDeveloperOnly = teamId === 697;

  const isPropertiesPageCustomizationEnabled = () => {
    return true;
  };

  const isClientPortalEnabled = () => {
    return true;
  };

  const isDocumentStorageEnabled = () => {
    return true;
  };

  const isFeatureEnabled = (feature: ToggledFeature) => {
    switch (feature) {
      case ToggledFeature.CLIENT_PORTAL:
        return isClientPortalEnabled();
      case ToggledFeature.DOCUMENT_STORAGE:
        return isDocumentStorageEnabled();
      case ToggledFeature.AILAUNCHER:
        return isForDefaultTeams;
      default:
        return false;
    }
  };

  return {
    isPropertiesPageCustomizationEnabled,
    isClientPortalEnabled,
    isDocumentStorageEnabled,
    isFeatureEnabled,
  };
}
